import {TaggingQueryKey} from "@/hooks/common/useTagging";
import {getQueryParams} from "@COMPONENTS/common/commonUtil";
import {commonMainMenu} from "@COMPONENTS/common/constants";
import {BannerContents} from "@QUERIES/essential/banner/useBannerContents";
import dayjs from "dayjs";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const utc = require("dayjs/plugin/utc");

/** braze 일정데이터 포맷 */
export const formatForTagging = (dateString: string, timeString: string, dayDiff = 0): string => {
	dayjs.extend(utc);
	return (
		dayjs(`${dateString}${timeString ?? ""}`, "YYYYMMDDHHmm")
			.add(dayDiff, "day")
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			.utc(true)
			.toISOString()
	);
};

export const getTaggingData = (key?: TaggingQueryKey) => {
	const tagging = window.tagging || {};
	return key ? tagging[key] ?? null : tagging;
};

export const setTaggingData = (key: TaggingQueryKey, value: any) => {
	if (!key || !value) return;
	window.tagging = window.tagging || {};
	window.tagging[key] = value;
};

/** global 데이터 */
export const menuForTagging = (paramDspSid?: string) => {
	try {
		const queryParams = getQueryParams();
		const queryDspSid = paramDspSid || (queryParams?.dspSid as string) || "";

		const globalMenuFetch = getTaggingData("useGlobalMenuBFF");
		const globalMenu = [...globalMenuFetch.menuLv1List, ...globalMenuFetch.menuLv2List, ...globalMenuFetch.menuLv3List];

		let menu = {dspNm: "-", dspMenu: "-", dspSid: "-"};
		// queryDspSid lv4 -> lv3 변환
		menu = globalMenu.find(e => e.dspSid === `${queryDspSid.slice(0, -2)}00`) ?? {
			dspNm: "-",
			dspMenu: "-",
			dspSid: "-",
		};

		const {dspNm: dspSidNm = "-", dspMenu: dspMenuCd = "-", dspSid: dspSidCd = "-"} = menu;
		const dspMenuNm = commonMainMenu[dspMenuCd] || "-";

		return {
			dspMenuCd, // GNB_코드
			dspMenuNm, // GNB_코드명
			dspSidCd, // 화면호출_코드
			dspSidNm, // 화면호출_코드명
		};
	} catch (error) {
		return null;
	}
};

/** ```
 * amplitude -
 * 		pkg_select_promo_calender
 *  	pkg_select_promo_locallist
 * 		pkg_select_promo_dtl
 * 기획전 배너 클릭 공용
 * selectDiv: "localListFilter" |
 * ```*/
export const taggingClickBanner = (contents: BannerContents & {selectDiv: string}) => {
	try {
		const {title, link, selectDiv = "-"} = contents;
		const queryParams = getQueryParams(link.split("?")[1]);
		return {
			selectDiv,
			promoNm: title,
			promoCd: queryParams?.mstNo || "-",
			promoLink: link,
		};
	} catch (e) {
		return null;
	}
};
